import * as React from "react";
import { useState, useEffect } from "react";
import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import Search from "../../../shared/components/Search";
import { getAllCollections } from "../../../services/collection";

interface FilterItem {
  label: string;
  selected: boolean;
  logoUrl: string;
  _id: string;
}

interface FilterData {
  collections: FilterItem[];
}

interface Props {
  setProductList?: any;
  productList?: any;
  handleChangeActiveFilters?: any;
  setActiveFilters?: any;
  activeFilters?: any;
}
// const filterData: FilterData = {
//   collections: [
//     { label: "Skyline", selected: true },
//     { label: "Pixel Boom", selected: false },
//     { label: "Sparkly", selected: true },
//     { label: "Winzy", selected: true },
//   ],
// };

const CollectionFiltersComponent: React.FC<Props> = ({
  setProductList,
  productList,
  handleChangeActiveFilters,
  setActiveFilters,
  activeFilters,
}) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [search, setSearch] = useState("");
  const [isTitleSelected, setIsTitleSelected] = useState<boolean>(false);
  // const [selectedFilterData, setSelectedFilterData] = useState<FilterData>({
  //   ...filterData,
  // });
  const [selectedFilterData, setSelectedFilterData] = useState<FilterData>({
    collections: [],
  });

  const [filteredCollections, setFilteredCollections] = useState<FilterItem[]>(
    []
  );

  const updateTitleCheckboxState = (collections: FilterItem[]) => {
    const allSelected = collections.every((item) => item.selected);
    setIsTitleSelected(allSelected);
  };

  // Fetch collections from API
  const fetchCollections = async (filters?: any) => {
    setLoading(true);
    try {
      const res = await getAllCollections(filters);
      const collections = res.paginatedCollections.map((collection: any) => ({
        label: collection.name,
        // selected: true,
        selected: false,
        logoUrl: collection.logoUrl,
        _id: collection._id,
      }));
      setSelectedFilterData({ collections });
      setFilteredCollections(collections);

      // Update title checkbox state based on stored data
      updateTitleCheckboxState(collections);

      // Save to local storage
      localStorage.setItem("collectionFilters", JSON.stringify(collections));

      // Add all collection IDs to active filters
      // const collectionIds = collections.map(
      //   (collection: any) => collection._id
      // );
      setActiveFilters((prev: any) => ({
        ...prev,
        // collections: collectionIds,
        collections: [],
      }));
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchCollections();
  // }, []);

  useEffect(() => {
    const storedCollections = localStorage.getItem("collectionFilters");
    if (storedCollections) {
      const collections = JSON.parse(storedCollections);
      setSelectedFilterData({ collections });
      setFilteredCollections(collections);

      // Update title checkbox state based on stored data
      updateTitleCheckboxState(collections);

      // Update active filters with only checked collections
      const collectionIds = collections
        .filter((item: any) => item.selected)
        .map((collection: any) => collection._id);

      setActiveFilters((prev: any) => ({
        ...prev,
        collections: collectionIds,
      }));
      setLoading(false);
    } else {
      fetchCollections({ includeComponents: true, type: "COMPONENT" });
    }
  }, []);

  useEffect(() => {
    // Filter collections based on search input
    const filtered = selectedFilterData.collections.filter((item) =>
      item.label.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredCollections(filtered);
  }, [search, selectedFilterData.collections]);

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const updatedFilterData = {
      ...selectedFilterData,
      collections: selectedFilterData.collections.map((item, i) =>
        i === index ? { ...item, selected: event.target.checked } : item
      ),
    };
    setSelectedFilterData(updatedFilterData);

    updateTitleCheckboxState(updatedFilterData.collections);

    // Check if all collections are selected to update Title checkbox
    // const allSelected = updatedFilterData.collections.every(
    //   (item) => item.selected
    // );
    // setIsTitleSelected(allSelected);

    // Call handleChangeActiveFilters with category ID
    //  const collectionId = filteredCollections[index]._id;
    //  handleChangeActiveFilters("collections", collectionId);

    // Call handleChangeActiveFilters with category ID
    // const collectionId = updatedFilterData.collections[index]._id;
    // setActiveFilters((prev: any) => {
    //   const updatedCategories = event.target.checked
    //     ? [...prev.collections, collectionId]
    //     : prev.collections.filter((id: string) => id !== collectionId);

    //   return {
    //     ...prev,
    //     collections: updatedCategories,
    //   };
    // });

    // Update active filters based on checked collections
    const collectionIds = updatedFilterData.collections
      .filter((item) => item.selected)
      .map((item) => item._id);
    setActiveFilters((prev: any) => ({
      ...prev,
      collections: collectionIds,
    }));

    // Save to local storage
    localStorage.setItem(
      "collectionFilters",
      JSON.stringify(updatedFilterData.collections)
    );
  };

  // useEffect(() => {
  //   // Check if all collections are selected to update Title checkbox
  //   const allSelected = selectedFilterData.collections.every(
  //     (item) => item.selected
  //   );
  //   setIsTitleSelected(allSelected);
  // }, [selectedFilterData.collections]);
  return (
    <>
      <Box>
        <Box sx={{ display: "flex", height: "52px", m: "24px 20px 12px 20px" }}>
          <Search
            searchFormStyles={{
              minHeight: "22px",
            }}
            style={{
              minHeight: "52px",
              color: "white",
              backgroundColor: "#292929",
              paddingLeft: "47px",
            }}
            icon={true}
            iconStyles={{
              position: "absolute",
              left: "15px",
            }}
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Box>
        <Box
          sx={{
            borderBottom: "1px solid #282828",
            height: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "0px 24px",
            mb: "12px",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={isTitleSelected}
                onChange={(event) => {
                  const isChecked = event.target.checked;
                  setIsTitleSelected(isChecked);

                  const updatedFilterData = {
                    ...selectedFilterData,
                    collections: selectedFilterData.collections.map((item) => ({
                      ...item,
                      selected: isChecked,
                    })),
                  };
                  setSelectedFilterData(updatedFilterData);

                  // Update activeFilters based on the Title checkbox state
                  const collectionIds = isChecked
                    ? updatedFilterData.collections.map((item) => item._id)
                    : [];
                  setActiveFilters((prev: any) => ({
                    ...prev,
                    collections: collectionIds,
                  }));

                  // Save to local storage
                  localStorage.setItem(
                    "collectionFilters",
                    JSON.stringify(updatedFilterData.collections)
                  );

                  updateTitleCheckboxState(updatedFilterData.collections);
                }}
                sx={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "6px",
                  padding: "4px",
                  border: isTitleSelected ? "" : "1px solid #3D3D3D",
                  "&.MuiCheckbox-root": {
                    color: "#1b1b1b",
                  },
                  "&.Mui-checked": {
                    color: "#CF0",
                    borderRadius: "6px",
                    "& .MuiSvgIcon-root": { fontSize: 28 },
                  },
                }}
              />
            }
            label="Title"
            labelPlacement="start"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              margin: 0,
              padding: 0,
              fontSize: "16px",
              fontWeight: 500,
              color: isTitleSelected ? "#FFFFFF" : "#8D8D8D",
            }}
          />
        </Box>
      </Box>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "75%",
          }}
        >
          <CircularProgress
            size={24}
            sx={{
              color: "white",
            }}
          />
        </Box>
      ) : (
        <Box sx={{ maxHeight: "100vh", marginX: "24px" }}>
          <FormGroup
            sx={{ display: "flex", flexDirection: "column", gap: "4px" }}
          >
            {/* {selectedFilterData.collections.map((item, index) => ( */}
            {filteredCollections.map((item, index) => (
              <>
                <Box
                  key={index}
                  sx={{
                    // borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
                    height: "50px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={item.selected}
                        onChange={(event) => handleCheckboxChange(event, index)}
                        sx={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "6px",
                          padding: "4px",
                          border: item.selected ? "" : "1px solid #3D3D3D",
                          "&.MuiCheckbox-root": {
                            color: "#1b1b1b",
                          },
                          "&.Mui-checked": {
                            color: "#CF0",
                            borderRadius: "6px",
                            "& .MuiSvgIcon-root": { fontSize: 28 },
                          },
                        }}
                      />
                    }
                    // label={item.label}
                    label={
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={item.logoUrl}
                          alt={item.label}
                          style={{
                            width: "18px",
                            height: "18px",
                            marginRight: "8px",
                          }}
                        />
                        {item.label}
                      </Box>
                    }
                    labelPlacement="start"
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      margin: 0,
                      padding: 0,
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 400,
                      color: "#FFFFFF",
                    }}
                  />
                </Box>
                {/* {index < selectedFilterData.collections.length - 1 ? ( */}
                {index < filteredCollections.length - 1 ? (
                  <Box
                    sx={{
                      width: "100%",
                      height: "1px",
                      bgcolor: "rgba(255, 255, 255, 0.06)",
                    }}
                  ></Box>
                ) : null}
              </>
            ))}
          </FormGroup>
        </Box>
      )}
    </>
  );
};

export default CollectionFiltersComponent;
